import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import storageSession from "redux-persist/es/storage/session";
import { persistReducer } from "redux-persist";
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";
import { PreferenceDetails } from "../services/KPIPreferences/savedKpiPreferencesAPI.types";

interface SavedKpiPreferencesState {
  savedKpiPreferencesData?: PreferenceDetails;
}

const initialSavedKpiPreferences: SavedKpiPreferencesState = {
  savedKpiPreferencesData: {
    savedDataViews: {},
  },
};

const { actions, reducer } = createSlice({
  name: "savedKpiPreferencesData",
  initialState: initialSavedKpiPreferences,
  reducers: {
    setSavedKpiPreferencesData: (state, { payload }: PayloadAction<PreferenceDetails | string>) => {
      try {
        return {
          ...state,
          savedKpiPreferencesData: typeof payload === "string" ? (JSON.parse(payload) as PreferenceDetails) : payload,
        };
      } catch (error) {
        return {
          ...state,
          savedKpiPreferencesData: payload as PreferenceDetails,
        };
      }
    },
  },
});

export const { setSavedKpiPreferencesData } = actions;

const persistConfig = {
  key: "savedKpiPreferencesData",
  storage: storageSession,
  stateReconciler: autoMergeLevel2,
};

export default persistReducer<SavedKpiPreferencesState>(persistConfig, reducer);
